
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ObjectType, SraEventAction } from '@/@types/graphql-types';

import Countdown from '@/components/Countdown.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import ChipButton from '@/ui-components/ChipButton.vue';
import CompetitorLogo from '../sports/common/CompetitorLogo.vue';
import CompetitionLogo from '../sports/common/competition/logos/CompetitionLogo.vue';
import RecommendationAdPill from './RecommendationAdPill.vue';

import { WebLocale } from '@/enums/web-locale';

import BackendTrackingMixin from '@/mixins/BackendTracking.vue';
import ImpressionTrackingMixin from '@/mixins/ImpressionTrackingMixin.vue';

import { SponsoredAdSportFragmentFragment } from '@/pages/graphql/fragments/SponsoredAdSport.fragment';

const Language = namespace('language');

@Component({
	name: 'SponsoredRecommendationSports',
	components: {
		BasicButton,
		ChipButton,
		CompetitionLogo,
		CompetitorLogo,
		Countdown,
		ProviderIcon,
		RecommendationAdPill,
	},
})
export default class SponsoredRecommendationSports extends Mixins(BackendTrackingMixin, ImpressionTrackingMixin) {
	ObjectType: ObjectType = ObjectType.SportEvent;

	@Language.State webLocale: WebLocale;

	@Prop({ default: 0 }) sponsoredAdData: SponsoredAdSportFragmentFragment;
	@Prop({ default: 0 }) timezoneOffset: number;

	/** IMPRESSION TRACKING */
	get observable() {
		return this.getObservableOptions(this.sponsoredRecommendationNode?.id);
	}
	/** IMPRESSION TRACKING */

	get sponsoredAdContent() {
		return this.sponsoredRecommendationNode?.content;
	}

	get sponsoredRecommendationNode() {
		return this.sponsoredAdCampaign?.node as any;
	}

	get sponsoredAdCampaign() {
		return this.sponsoredAdData?.campaign;
	}

	get isMatchLive() {
		return this.sponsoredAdContent.status === 'LIVE';
	}
	get matchTime() {
		return Intl.DateTimeFormat(this.webLocale, {
			hour: '2-digit',
			minute: '2-digit',
		}).format(new Date(this.sponsoredAdContent.startAt));
	}

	get matchDate() {
		return `${Intl.DateTimeFormat(this.webLocale, {
			weekday: 'short',
		}).format(new Date(this.sponsoredAdContent.startAt))} ${Intl.DateTimeFormat(this.webLocale, {
			month: 'short',
		}).format(new Date(this.sponsoredAdContent.startAt))} ${Intl.DateTimeFormat(this.webLocale, {
			day: '2-digit',
		}).format(new Date(this.sponsoredAdContent.startAt))}`;
	}
	get matchDatetime() {
		return new Date(this.sponsoredAdContent.startAt).getTime();
	}
	get liveIn() {
		const now = new Date().getTime();
		const start = new Date(this.sponsoredAdContent.startAt).getTime();
		const diff = start - now;
		const minutes = Math.floor(diff / 1000 / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);
		if (days > 0) return `${days} days`;
		if (hours > 0) return `${hours} hours`;
		if (minutes > 0) return `${minutes} minutes`;
		return '0 minutes';
	}

	get competitors() {
		return this.sponsoredRecommendationNode?.competitors;
	}

	get competition() {
		return this.sponsoredRecommendationNode?.competition;
	}

	get matchLink() {
		return this.sponsoredAdContent?.fullPath;
	}

	get offer() {
		return {
			// DAZN
			package: { packageId: 695 },
		};
	}
	get clickoutURL() {
		return 'https://click.justwatch.com/a?r=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1011lpG2W%2Fdestination%3ADEEPLINK&cx=eyJzY2hlbWEiOiJpZ2x1OmNvbS5zbm93cGxvd2FuYWx5dGljcy5zbm93cGxvdy9jb250ZXh0cy9qc29uc2NoZW1hLzEtMC0wIiwiZGF0YSI6W3sic2NoZW1hIjoiaWdsdTpjb20uanVzdHdhdGNoL2NsaWNrb3V0X2NvbnRleHQvanNvbnNjaGVtYS8xLTItMCIsImRhdGEiOnsicHJvdmlkZXIiOiJEQVpOIiwicHJvdmlkZXJJZCI6Njk1LCJtb25ldGl6YXRpb25UeXBlIjoiZmxhdHJhdGUiLCJwcmVzZW50YXRpb25UeXBlIjoiaGQiLCJwYXJ0bmVySWQiOjF9fV19&uct_country=DE&uct_buybox=sports&uct_sport=football&sid=&uct_ct=&uct_itsct=';
	}

	get competitionURL() {
		return this.sponsoredRecommendationNode?.competition.content.fullPath;
	}

	impressionCallback() {
		this.$backendTracking.trackSraEvent(SraEventAction.Impression, this.sponsoredAdData);
	}

	watchNowClick() {
		this.$backendTracking.trackSraEvent(SraEventAction.WatchnowClicked, this.sponsoredAdData);
	}

	moreClick() {
		this.$backendTracking.trackSraEvent(SraEventAction.MoreInfoClicked, this.sponsoredAdData);
	}

	cardClick(event: any) {
		this.$backendTracking.trackSraEvent(SraEventAction.Click, this.sponsoredAdData);
		if (!event.target.classList.contains('league__name')) window.open(this.clickoutURL, '_blank');

		event.preventDefault();
	}
}
